<template>
  <div v-if="moisComptable">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ $t('detailMoisComptable.title',
              { periode: `${formatDate(moisComptable.dateDebut)}
                - ${formatDate(moisComptable.dateFin)}` }) }}
          </h1>
        </div>
        <div class="column is-narrow pdb-0">
          <div class="is-pulled-right buttons boutonAction">
            <button
              @click="checkPermissions(permissions.maj) ? $router.push({
                name: 'm.presse.mois_comptable-edit',
                params: { id: moisComptable.id },
              }) : showPopUpPermission()"
              :class="{'button-access-no-permission':
                !checkPermissions(permissions.maj)}"
              class="button is-addOrEdit">
              <span>
                {{ $t('general.button.edit') }}
              </span>
            </button>
            <b-dropdown class="button is-bottom-left has-text-left">
              <div slot="trigger">
                <b-icon icon="file-download" type="is-default"></b-icon>
                <b-icon icon="chevron-down" class="has-text-secondary-icon"></b-icon>
              </div>
              <b-dropdown-item
                @click="checkPermissions(permissions.editer)
                  ? edition({
                    format: constantes.pdf,
                    typeDonnee: constantes.typeEditionCommissionsVendeur
                  })
                  : showPopUpPermission()">
                {{ $t('detailMoisComptable.actions.editionCommerciaux') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="checkPermissions(permissions.editer)
                  ? edition({
                    format: constantes.pdf,
                    typeDonnee: constantes.typeEditionCommissionsVendeur,
                    isAnterieures: true,
                  })
                  : showPopUpPermission()">
                {{ $t('detailMoisComptable.actions.editionCommerciauxAnterieures') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <breadcrumb :breadcrumb="breadcrumb"/>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'information'}"
              @click="activeTab = 'information'">
            {{ $t('detailMoisComptable.tab.info') }}
          </li>
          <li :class="{'is-active': activeTab === 'comVendeur'}"
              @click="activeTab = 'comVendeur'">
            {{ $t('detailMoisComptable.tab.comVendeur') }}
          </li>
          <li :class="{'is-active': activeTab === 'comFournisseur'}"
              @click="activeTab = 'comFournisseur'">
            {{ $t('detailMoisComptable.tab.comFournisseur') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsAnterieuresVendeur'}"
              @click="activeTab = 'commissionsAnterieuresVendeur'">
            {{ $t('detailMoisComptable.tab.commissionsAnterieuresVendeur') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsAnterieuresFournisseur'}"
              @click="activeTab = 'commissionsAnterieuresFournisseur'">
            {{ $t('detailMoisComptable.tab.commissionsAnterieuresFournisseur') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsGaranties'}"
              @click="activeTab = 'commissionsGaranties'">
              <b-tooltip v-if="anyCommissionsGarantieAGenerer"
                :label="$t('detailMoisComptable.tab.tooltip.commissionsGarantiesAGenerer')"
                type="is-warning"
                position="is-top">
                        <b-icon icon="circle" :type="'is-warning'"/>
                      </b-tooltip>
              {{ $t('detailMoisComptable.tab.commissionsGaranties') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsRegrpGaranties'}"
              @click="activeTab = 'commissionsRegrpGaranties'">
              <b-tooltip v-if="anyCommissionsRegrpGarantieAGenerer"
                :label="$t('detailMoisComptable.tab.tooltip.commissionsGarantiesAGenerer')"
                type="is-warning"
                position="is-top">
                        <b-icon icon="circle" :type="'is-warning'"/>
                      </b-tooltip>
              {{ $t('detailMoisComptable.tab.commissionsRegrpGaranties') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="corps">
      <component
        :is="activeTab"
        :detail="true"
        :dates="getDates"
        :mois-comptable="moisComptable"
        :date-now="lastDateMoisAnt"
        :commandesCommissionsGaranties="commandesCommissionsGaranties"
        :commandesCommissionsRegrpGaranties="commandesCommissionsRegrpGaranties"
        :reglesAchatGarantiesInput="reglesAchatGaranties"
        :reglesAchatRegrpGarantiesInput="reglesAchatRegrpGaranties"
        @commissionGarantieGeneree="refreshCommissionsGaranties"
        @commissionRegrpGarantieGeneree="refreshCommissionsRegrpGaranties"
        filtre-commissions-ant/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { get, getReglesAchatGarantiesAsync } from '@/api/presse/moisComptable';
import { PGetAllForReglesAchatsAsync } from '@/api/commissionVendeur/index';
import edition from '@/api/edition';
import { MOIS_COMPTABLE } from '@/configuration/presse/permissionsPresseConf';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { TYPE_EDITION_COMMISSSIONS_VENDEUR } from '@/configuration/presse/moisComptable/moisComptable';
import breadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Information from '@/components/presse/moisComptable/information/information';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';
import comVendeur from '@/components/commissions/listeCommissions';
import commissionsAnterieuresVendeur from '@/components/commissions/listeCommissionsAnterieuresVendeur';
import commissionsAnterieuresFournisseur from '@/components/commissions/listeCommissionsAnterieuresFournisseur';
import commissionsGaranties from '@/components/commissions/listeCommissionsGaranties';
import commissionsRegrpGaranties from '@/components/commissions/listeCommissionsRegrpGaranties';
import moment from 'moment';
import comFournisseur from '@/components/factures/detail/commissionsFournisseur';
import * as typesCommande from '@/store/modules/commande-mutation-type';
import cloneDeep from 'lodash/cloneDeep';

const CommandeAchat = createNamespacedHelpers('commandeAchat');
const Permissions = createNamespacedHelpers('permissions');
const CommandeAchatAnterieure = createNamespacedHelpers('commandeAchatAnterieureVendeur');

export default {
  name: 'c_moisComptable',
  components: {
    breadcrumb,
    errorMsgComponent,
    Information,
    comVendeur,
    comFournisseur,
    commissionsAnterieuresVendeur,
    commissionsAnterieuresFournisseur,
    commissionsGaranties,
    commissionsRegrpGaranties,
  },
  data() {
    return {
      commandesCommissionsGaranties: [],
      commandesCommissionsRegrpGaranties: [],
      reglesAchatGaranties: [],
      reglesAchatRegrpGaranties: [],
      permissions: MOIS_COMPTABLE,
      activeTab: 'information',
      moisComptable: null,
      constantes: {
        pdf: TYPE_PDF,
        typeEditionCommissionsVendeur: TYPE_EDITION_COMMISSSIONS_VENDEUR,
      },
    };
  },
  computed: {
    ...CommandeAchat.mapGetters({
      lastDataFromLoad: 'lastDataFromLoad',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...CommandeAchatAnterieure.mapGetters({
      critereRechercheCmdAchatAnt: 'criteresRecherche',
      lastDataFromLoadAnterieure: 'lastDataFromLoad',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailMoisComptable.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailMoisComptable.breadcrumb.liste'), route: { name: 'l.presse.mois_comptable' }, isActive: false },
        { title: this.$i18n.t('detailMoisComptable.breadcrumb.detail', { code: '' }), route: { name: '' }, isActive: true },
      ];
    },
    getDates() {
      return {
        dateDebut: moment(this.moisComptable.dateDebut).toDate(),
        dateFin: moment(this.moisComptable.dateFin).toDate(),
      };
    },
    lastDateMoisAnt() {
      if (!this.moisComptable) return null;
      return moment(this.moisComptable.dateDebut)
        .subtract(1, 'd').toDate();
    },
    commercialIdFilter() {
      return this.lastDataFromLoad?.Query?.commercialId || [];
    },
    anyCommissionsGarantieAGenerer() {
      let anyCommissionGarantieAGenerer = false;
      this.reglesAchatGaranties.every(r => {
        const anyCommissionPourCetteRegle = this.commandesCommissionsGaranties
          .some(comm => comm.referenceExterne5Id === r.id);
        if (!anyCommissionPourCetteRegle) {
          anyCommissionGarantieAGenerer = true;
          return false;
        }
        return true;
      });
      return anyCommissionGarantieAGenerer;
    },
    anyCommissionsRegrpGarantieAGenerer() {
      let anyCommissionGarantieAGenerer = false;
      this.reglesAchatRegrpGaranties.every(r => {
        const reglesAchatPourCeRegrp = this.reglesAchatRegrpGaranties.filter(autreR => {
          return autreR.produit.regroupementProduitId === r.produit.regroupementProduitId;
        }).map(autreR => autreR.id);
        const anyCommissionPourCetteRegle = this.commandesCommissionsRegrpGaranties
          .some(comm => reglesAchatPourCeRegrp.includes(comm.referenceExterne5Id));
        if (!anyCommissionPourCetteRegle) {
          anyCommissionGarantieAGenerer = true;
          return false;
        }
        return true;
      });
      return anyCommissionGarantieAGenerer;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...CommandeAchatAnterieure.mapMutations({
      setCriteresRechercheCmdAchatAnt: typesCommande.SET_CRITERE_RECHERCHE,
    }),
    postGetMoisComptable(moisComptable) {
      if (moisComptable.dateDebut) moisComptable.dateDebut = new Date(moisComptable.dateDebut);
      if (moisComptable.dateFin) moisComptable.dateFin = new Date(moisComptable.dateFin);
      return moisComptable;
    },
    formatDate(date) {
      return formatDate(date);
    },
    hanldeLastPayload(donnees) {
      let payload = cloneDeep(this.lastDataFromLoad.Query);
      if (donnees.isAnterieures) {
        payload = cloneDeep(this.lastDataFromLoadAnterieure.Query);
      }
      payload.commercialId = payload.commercialId?.join('|');
      payload.planMediaIds = payload.planMediaIds?.join('|');
      payload.referencesExternesCommandesIds = payload.referencesExternesCommandesIds?.join('|');
      payload.referencesExternesFacturesIds = payload.referencesExternesFacturesIds?.join('|');
      payload.remisesBancairesIds = payload.remisesBancairesIds?.join('|');
      payload.dateDebut = payload.dates.dateDebut;
      payload.dateFin = payload.dates.dateFin;
      delete payload.dates;
      payload.typesReferenceExterne = payload.typesReferenceExterne.join('|');
      payload.commissionEtat = payload.commissionEtat?.join('|');
      return payload;
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      const payload = this.hanldeLastPayload(donnees);
      try {
        const editionInput = {
          ids: [this.moisComptable.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: payload,
        };

        const response = await edition(editionInput);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    refreshCommissionsGaranties(commissionsGaranties) {
      this.commandesCommissionsGaranties = commissionsGaranties;
    },
    refreshCommissionsRegrpGaranties(commissionsRegrpGaranties) {
      this.commandesCommissionsRegrpGaranties = commissionsRegrpGaranties;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const moisComptable = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: formatDate(moisComptable.dateDebut) + ' - ' + formatDate(moisComptable.dateFin) }));
      this.moisComptable = this.postGetMoisComptable(moisComptable);
      this.setCriteresRechercheCmdAchatAnt({
        ...this.critereRechercheCmdAchatAnt,
        dates: { dateDebut: null, dateFin: this.lastDateMoisAnt },
      });

      const reglesAchat = await getReglesAchatGarantiesAsync(this.moisComptable.id, false);
      const reglesAchatIds = reglesAchat.data.result.map(r => r.id);
      const commandesCommissions = await PGetAllForReglesAchatsAsync(reglesAchatIds);
      const reglesAchatRegrp = await getReglesAchatGarantiesAsync(this.moisComptable.id, true);
      const reglesAchatRegrpIds = reglesAchatRegrp.data.result.map(r => r.id);
      const commandesCommissionsRegrp = await PGetAllForReglesAchatsAsync(reglesAchatRegrpIds);

      this.commandesCommissionsGaranties = commandesCommissions.data.result;
      this.reglesAchatGaranties = reglesAchat.data.result;
      this.commandesCommissionsRegrpGaranties = commandesCommissionsRegrp.data.result;
      this.reglesAchatRegrpGaranties = reglesAchatRegrp.data.result;
      this.refreshCommissionsGaranties(this.commandesCommissionsGaranties);
      this.refreshCommissionsRegrpGaranties(this.commandesCommissionsRegrpGaranties);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
